import {
  commonValidationSchemas,
  createValidationSchema,
} from 'infrastructure/functions';

import type { TSchema } from 'infrastructure/functions';

export const bulkCommentGenerateValidationSchema = () =>
  createValidationSchema({
    concerns: commonValidationSchemas.string(),
    comment: commonValidationSchemas.string().when('concerns', {
      is: 'yes',
      then: (schema) => schema.required('Comment is required'),
      otherwise: (schema) => schema.notRequired(),
    }),
  });

export type ValuesBulkCommentGenerate = TSchema<
  ReturnType<typeof bulkCommentGenerateValidationSchema>
>;

export const bulkCommentSubmitValidationSchema = () =>
  createValidationSchema({
    patientGuid: commonValidationSchemas.string().required(),
    comment: commonValidationSchemas.string().required(),
  });

export type ValuesBulkCommentSubmit = TSchema<
  ReturnType<typeof bulkCommentSubmitValidationSchema>
>;
